import { takeEvery } from 'redux-saga/effects';

import { XCRITICAL_FORM_PROPERTY_CHANGE } from '@xcritical/forms';

import {
  PROMO_GET,
  PROMO_SAVE,
  PROMO_ADD_RULE,
  PROMO_REMOVE_RULE,
} from '../actions';

import {
  handleGetPromo,
  handleAddRule,
  handleRemoveRule,
  validateForm,
  handleSavePromo,
} from './sagas';

export function* watchGetPromo() {
  yield takeEvery(PROMO_GET, handleGetPromo);
  yield takeEvery(PROMO_ADD_RULE, handleAddRule);
  yield takeEvery(PROMO_REMOVE_RULE, handleRemoveRule);
  yield takeEvery(XCRITICAL_FORM_PROPERTY_CHANGE, validateForm);
  yield takeEvery(PROMO_SAVE, handleSavePromo);
}
